interface Props {
  title: string;
  slug: string;
}

export default function ShareButtons({ title, slug }: Props) {
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
  const url = encodeURIComponent(`${baseUrl}/blog/${slug}`);
  const text = encodeURIComponent(title);

  const shares = [
    {
      label: 'LinkedIn',
      icon: 'ri-linkedin-fill',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
      bg: 'bg-[#0077B5] hover:bg-[#005f94]',
    },
    {
      label: 'WhatsApp',
      icon: 'ri-whatsapp-fill',
      href: `https://api.whatsapp.com/send?text=${text}%20${url}`,
      bg: 'bg-[#25D366] hover:bg-[#1db954]',
    },
    {
      label: 'Twitter / X',
      icon: 'ri-twitter-x-fill',
      href: `https://twitter.com/intent/tweet?text=${text}&url=${url}`,
      bg: 'bg-gray-900 hover:bg-gray-700',
    },
  ];

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <span className="font-body text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">
        Compartilhar
      </span>
      {shares.map(s => (
        <a
          key={s.label}
          href={s.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Compartilhar no ${s.label}`}
          title={s.label}
          className={`w-9 h-9 flex items-center justify-center rounded-full text-white transition-all duration-200 hover:scale-110 cursor-pointer ${s.bg}`}
        >
          <i className={`${s.icon} text-sm`}></i>
        </a>
      ))}
    </div>
  );
}
